import {useEffect} from "react";

const AgreementUsers = () => {

  useEffect(() => {
    window.scrollTo(10, 10)
  }, [])

  return (
    <div className="px-4 md:px-56 my-10 md:my-20">
      <h1 className="text-center font-bold text-3xl">СОГЛАШЕНИЕ О ЗАЩИТЕ ПЕРСОНАЛЬНЫХ ДАННЫХ ПОЛЬЗОВАТЕЛЕЙ</h1>
      <p className="mt-4">Настоящее Соглашение о защите персональных данных пользователей (далее
          — «Соглашение») разработано в соответствии с законодательством Республики
          Казахстан, включая Закон Республики Казахстан от 21 мая 2013 г. № 94-V «О
          персональных данных и их защите», а также другими нормативными правовыми актами.
      </p>
          <p className="mt-4">Соглашение регулирует отношения, возникающие между Товариществом с
              ограниченной ответственностью «DOM FOOD (ДОМ ФУД)» (далее — «Компания») и
              любым пользователем, использующим онлайн-платформу DOM FOOD (далее —
              «Платформа»), по вопросам сбора, хранения, обработки и защиты персональных данных,
              предоставляемых Компании при использовании Платформы.</p>

        <p className="mt-4">Используя Платформу Компании (включая веб-сайты https://dom-food.com и
            https://domfood.kz, а также мобильное приложение DOM FOOD), Пользователь
            подтверждает, что ознакомился с настоящим Соглашением, принимает его условия и
            выражает согласие на обработку персональных данных в соответствии с его положениями.
            В случае несогласия с условиями Соглашения, Пользователь обязан воздержаться от
            использования Платформы и предоставления персональных данных.</p>

      <h3 className="font-bold text-2xl mt-4 text-center">1. ПОНЯТИЯ И ТЕРМИНЫ</h3>
      <p>
        <p><br/></p> 1.1. Для целей настоящего Соглашения все термины, написанные с заглавной
          буквы и не раскрытые в тексте, подлежат толкованию в соответствии с законодательством
          Республики Казахстан, включая Закон РК от 21 мая 2013 г. № 94-V «О персональных
          данных и их защите».
        <p><br/></p> 1.2. Компания — Товарищество с ограниченной ответственностью «DOM FOOD
          (ДОМ ФУД)», зарегистрированное в Республике Казахстан и осуществляющее
          деятельность в соответствии с законодательством, являющееся владельцем и оператором
          Платформы.
        <p><br/></p> 1.3.  Платформа — совокупность технических и организационных решений
          Компании, включающая веб-сайты (https://dom-food.com и https://domfood.kz), мобильное
          приложение DOM FOOD, а также внутренние интерфейсы и модули, предназначенные
          для взаимодействия с Пользователями, в том числе для оформления заказов,
          коммуникации и доступа к сервисам Компании.
        <p><br/></p> 1.4. Сайт — часть Платформы, доступная в форме интернет-ресурса с информацией
          в текстовом, графическом, аудиовизуальном или ином формате, размещённой на
          аппаратно-программном комплексе с уникальным сетевым адресом и (или) доменным
          именем, функционирующим в сети Интернет по адресам https://dom-food.com и
          https://domfood.kz.
        <p><br/></p> 1.5. Пользователь — физическое лицо, обладающее полной дееспособностью,
          использующее Платформу и добровольно предоставившее Компании свои персональные
          данные
          <p><br/></p> 1.6. Стороны — совместно именуемые в настоящем Соглашении Компания и
          Пользователь.
          <p><br/></p> 1.7. Персональные данные — сведения, относящиеся к Пользователю, а также
          любые их изменения и (или) дополнения в будущем, зафиксированные на электронных,
          бумажных или иных материальных носителях, включая, но не ограничиваясь:
        <p><br/></p> 1.7.1.фамилия, имя, отчество (при наличии);
        <p><br/></p>  1.7.2. индивидуальный идентификационный номер (ИИН);
        <p><br/></p>  1.7.3. дату рождения;
        <p><br/></p>  1.7.4. почтовый адрес (место жительства), номер мобильного телефона и адрес электронной
        почты;
        <p><br/></p>  1.7.5. Платёжные данные, включая реквизиты банковского счёта или карты;
          <p><br/></p>  1.7.6. Данные, полученные в процессе использования Платформы (история заказов,
          действия в Личном кабинете, IP-адрес и др.).
        <p><br/></p>  1.8. Обработка персональных данных — любые действия или совокупность
          действий, совершаемые Компанией в отношении персональных данных Пользователя,
          включая сбор, систематизацию, накопление, уточнение (обновление или изменение),
          использование, распространение (включая передачу), обезличивание, блокирование,
          уничтожение и хранение Персональных данных, как с использованием средств
          автоматизации, так и без них
          <p><br/></p>1.9. Третьи лица — любые физические или юридические лица, не являющиеся
          сотрудниками Компании, которым в рамках настоящего Соглашения может быть передана
          информация о Пользователе, в том числе курьеры, повара, платёжные провайдеры,
          подрядчики, партнёры и иные лица, чьё участие необходимо для исполнения функций
          Платформы.
          <p><br/></p> 1.10. Личный кабинет — раздел Платформы, предназначенный для управления
          Пользователем своей учётной записью, в том числе для редактирования персональных
          данных, просмотра заказов и связи с поддержкой
      </p>
      <h3 className="font-bold text-2xl mt-4 text-center">2. ПРЕДМЕТ СОГЛАШЕНИЯ</h3>
    <p>
      <p><br/></p> 2.1. Пользователь предоставляет Компании, как оператору персональных данных,
        свои данные и выражает полное и безоговорочное согласие на их обработку. Это согласие
        предоставляется свободно и добровольно, на условиях, установленных настоящим
        Соглашением. Обработка данных осуществляется в электронном виде и используется
        исключительно для целей, предусмотренных данным документом.
      <p><br/></p>2.2. Моментом предоставления согласия считается регистрация Пользователя на
        Платформе либо любое действие, свидетельствующее о дальнейшем использовании
        Платформы. Согласие действует бессрочно до его отзыва.
      <p><br/></p> 2.3. Дата выдачи согласия совпадает с моментом ознакомления Пользователя с
        Соглашением и нажатием кнопки «Зарегистрироваться». Пользователь может отозвать
        согласие путём направления письменного уведомления на электронную почту Компании;
        отзыв считается совершённым через 10 (десять) рабочих дней после получения
        уведомления.
        <p><br/></p>
        2.4. Обработка персональных данных осуществляется Компанией для следующих
        целей, включая, но не ограничиваясь:
      <p><br/></p> 2.4.1. проведение внутренних и внешних исследований для повышения качества и доступности
      предоставляемых услуг;
      <p><br/></p>2.4.2. реализация маркетинговых программ, статистических исследований и анализа данных для
      разработки новых сервисов и улучшения текущих;
      <p><br/></p> 2.4.3. продвижение услуг Сайта, включая отправку персонализированной (таргетированной)
      рекламы, взаимодействие с Пользователем через почтовую рассылку, электронную почту,
      телефонную связь и иные каналы.
      <p><br/></p> 2.4.4. обеспечение безопасности операций, в том числе для предотвращения мошенничества,
      защиты прав Компании и Пользователей.
      <p><br/></p> 2.4.5. выполнение обязательств Компании перед Пользователем, включая уведомление о статусе
      заказов, акциях и изменениях на платформе.
        <p><br/></p> 2.4.6. Анализ и улучшение качества оказываемых услуг.

      <p><br/></p>2.5. Обязательства Компании по защите персональных данных включают:
      <p><br/></p> 2.5.1. предотвращение несанкционированного доступа к персональным данным Пользователя;
      <p><br/></p> 2.5.2. оперативное выявление фактов утечки или несанкционированного доступа и принятие мер
      по их устранению;
      <p><br/></p> 2.5.3.минимизацию негативных последствий в случае утечки данных или иного инцидента;
      <p><br/></p> 2.5.4. внедрение передовых технических и организационных мер для защиты данных,
      соответствующих международным стандартам.
      <p><br/></p> 2.6. Обязательства вступают в силу с момента получения данных и действуют до их
        уничтожения или обезличивания, за исключением случаев, предусмотренных законом.
      <p><br/></p> 2.7. Отзыв согласия не распространяется на обработку данных до момента отзыва и
        не освобождает от обязательств, возникших ранее
        <p><br/></p> 2.8. Трансграничная передача данных возможна при условии соблюдения
        законодательства Республики Казахстан и обеспечения адекватного уровня защиты
        данных.
    </p>
      <h3 className="font-bold text-2xl mt-4 text-center">3. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h3>
    <p>
        <p><br/></p>3.1. Права Пользователя
        <p><br/></p> 3.1.1. Запрашивать у Компании информацию о порядке и условиях обработки своих
        персональных данных (подтверждение факта обработки, цели, перечень данных,
        источники получения и т. д.).
        <p><br/></p>3.1.2. Требовать уточнения (обновления, изменения), блокирования или удаления
        своих персональных данных в случаях, когда данные неполные, устаревшие, неточные,
        незаконно полученные или не требуются для заявленных целей.
        <p><br/></p> 3.1.3. Отозвать согласие на обработку персональных данных в порядке,
        установленном настоящим Соглашением.
        <p><br/></p> 3.1.4. Возражать против обработки персональных данных, в том числе в целях
        прямого маркетинга.
        <p><br/></p>3.1.5. Обращаться в уполномоченные государственные органы за защитой своих
        прав в области защиты персональных данных.
        <p><br/></p> 3.2. Обязанности Пользователя
        <p><br/></p> 3.2.1. Предоставлять Компании достоверные и актуальные персональные данные.
        <p><br/></p> 3.2.2. Обновлять свои персональные данные при их изменении.
        <p><br/></p> 3.2.3. Соблюдать конфиденциальность своих учётных данных (логина, пароля) и не
        передавать их третьим лицам.
        <p><br/></p> 3.3. Права Компании
        <p><br/></p> 3.3.1. Осуществлять обработку персональных данных Пользователя в объёме и на
        условиях, предусмотренных настоящим Соглашением.
        <p><br/></p> 3.3.2. Передавать персональные данные Пользователя третьим лицам в случаях,
        прямо предусмотренных настоящим Соглашением или законодательством Республики
        Казахстан, и только в объёме, необходимом для исполнения услуг.
        <p><br/></p> 3.4. Обязанности Компании
        <p><br/></p> 3.4.1. Обрабатывать персональные данные строго в соответствии с целями,
        указанными в разделе 2 настоящего Соглашения.
        <p><br/></p> 3.4.2. Обеспечивать конфиденциальность и безопасность персональных данных,
        принимая необходимые технические и организационные меры.
        <p><br/></p> 3.4.3. Уведомлять Пользователя и (при необходимости) уполномоченные органы о
        фактах несанкционированного доступа или утечки данных.
        <p><br/></p> 3.4.4. По запросу Пользователя предоставлять информацию о наличии и объёме его
        персональных данных, а также о порядке их обработки.
        <p><br/></p> 3.5. Ответственность за недостоверность данных: Компания не несёт
        ответственности за убытки Пользователя, возникшие вследствие предоставления им
        недостоверных или неполных персональных данных.
        <p><br/></p>3.6. Уведомление об инцидентах: В случае утечки или несанкционированного
        доступа к персональным данным Компания обязуется предпринять меры для устранения
        последствий и уведомить об этом Пользователя в разумные сроки.
        <p><br/></p>  3.7. Передача данных третьим лицам: Передача персональных данных третьим
        лицам осуществляется только в необходимых объёмах и в целях исполнения Соглашения
        (доставка, оплата, взаимодействие с партнёрами) или в случаях, предусмотренных
        законом.
        <p><br/></p> 3.8. Достоверность предоставленных данных: Компания исходит из того, что
        Пользователь предоставляет достоверные персональные данные добросовестно и в
        полном объёме.
        <p><br/></p>  3.9. Конфиденциальность: Все персональные данные Пользователей являются
        конфиденциальной информацией и не подлежат разглашению, за исключением случаев,
        предусмотренных настоящим Соглашением или законом.
        <p><br/></p> 3.10. Срок хранения данных: Персональные данные хранятся в течение срока,
        необходимого для достижения целей обработки, либо до удаления Пользователем, за
        исключением случаев, когда более длительный срок хранения установлен
        законодательством.
    </p>
        <h3 className="font-bold text-2xl mt-4 text-center">4. ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ</h3>
        <p>
            <p><br/></p>4.1. Все споры и разногласия, возникающие из настоящего Соглашения или в связи
            с ним, решаются путём переговоров между Сторонами.
            <p><br/></p> 4.2. Если в течение 30 календарных дней с момента направления письменной
            претензии одна из Сторон не дала ответа или не достигнуто соглашение, спор передаётся
            на рассмотрение в суд по месту регистрации Компании.
            <p><br/></p> 4.3. Срок для ответа на претензию составляет 10 рабочих дней с момента её
            получения.
            <p><br/></p> 4.4. До передачи спора в суд Стороны обязуются предпринять все необходимые
            меры для его урегулирования во внесудебном порядке.
        </p>

        <h3 className="font-bold text-2xl mt-4 text-center">5. ИЗМЕНЕНИЕ И ДОПОЛНЕНИЕ СОГЛАШЕНИЯ</h3>
        <p>
            <p><br/></p> 5.1. Компания вправе в одностороннем порядке вносить изменения и дополнения в
            настоящее Соглашение для приведения его в соответствие с изменениями
            законодательства, внутренних регламентов Компании или технических особенностей
            Платформы.
            <p><br/></p> 5.2. Изменения и дополнения вступают в силу с момента их публикации на
            Платформе (веб-сайтах и в мобильном приложении) или с иной даты, указанной в тексте
            изменений.
            <p><br/></p> 5.3. О факте внесения изменений Компания уведомляет Пользователя при
            следующем входе в Платформу посредством всплывающего уведомления или рассылки на
            электронную почту, указанную при регистрации.
            <p><br/></p> 5.4. Продолжение использования Платформы после даты вступления изменений
            означает полное принятие Пользователем новой редакции Соглашения.
            <p><br/></p>5.5. В случае несогласия с условиями новой редакции Соглашения Пользователь
            вправе прекратить использование Платформы и потребовать удаления своих
            персональных данных в порядке, предусмотренном разделом 6 настоящего Соглашения.
        </p>

        <h3 className="font-bold text-2xl mt-4 text-center">6.  ОТЗЫВ СОГЛАСИЯ</h3>
        <p>
            <p><br/></p> 6.1. Пользователь вправе в любой момент отозвать своё согласие на обработку
            персональных данных, направив письменное уведомление на электронную почту
            Компании: support@dom-food.com.
            <p><br/></p> 6.2. После получения уведомления об отзыве согласия Компания прекращает
            обработку персональных данных Пользователя и удаляет или обезличивает их в течение
            10 рабочих дней, за исключением данных, которые Компания обязана хранить в силу
            требований законодательства или исполнения договорных обязательств.
            <p><br/></p> 6.3. Отзыв согласия может повлечь невозможность дальнейшего использования
            Платформы или отдельных её функций. Компания информирует Пользователя о
            возможных ограничениях при отзыве согласия.
        </p>

        <h3 className="font-bold text-2xl mt-4 text-center">7. ПРИМЕНИМОЕ ПРАВО</h3>
        <p>
            <p><br/></p>7.1. Настоящее Соглашение регулируется законодательством Республики
            Казахстан.
            <p><br/></p>7.2. Все вопросы, не урегулированные настоящим Соглашением, разрешаются в
            соответствии с законодательными актами Республики Казахстан.
        </p>
        <h3 className="font-bold text-2xl mt-4 text-center">8. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h3>
        <p>
            <p><br/></p>  8.1. Настоящее Соглашение вступает в силу с момента его размещения на
            Платформе и действует до момента публикации новой редакции.
            <p><br/></p> 8.2. Актуальная версия Соглашения всегда доступна по адресу: https://domfood.com/agreement_users.
            <p><br/></p>  8.3. Пользователь обязан самостоятельно отслеживать изменения Соглашения;
            дальнейшее использование Платформы после публикации новой редакции означает
            согласие с её условиями.
            <p><br/></p>  8.4. Недействительность какого-либо положения Соглашения не влечёт
            недействительность остальных его положений
        </p>
        <h3 className="font-bold text-2xl mt-4 text-center">9. РЕКВИЗИТЫ КОМПАНИИ</h3>
        <p>
            <p><br/></p>9.1. Полное наименование: Товарищество с ограниченной ответственностью «DOM
            FOOD (ДОМ ФУД)»
            <p><br/></p>9.2. БИН: 240940031813
            <p><br/></p> 9.3. Юридический адрес: Республика Казахстан, город Астана, район Байконыр,
            улица Амангельдi Иманов, дом 19, офис 78, индекс 010000
        </p>
    </div>
  )
  }

  export default AgreementUsers